<div class="filtro-item" [class.filtro-item-horario]="modoHorario">
  <label class="filtro-item-label" *ngIf="modoHorario">{{ nome }}</label>

  <ng-container *ngIf="!modoHorario">
    <div class="filtro-item-field">
      <input
        #searchInput
        id="filtro-busca-{{ filtroNome }}"
        class="search-input"
        type="text"
        placeholder="Busca pela placa, motorista ou identificação da rota"
        matTooltip="Busca pela placa, motorista ou identificação da rota"
        matTooltipPosition="above"
        matTooltipShowDelay="400"
        [formControl]="comparadoresForm"
        (keydown.enter)="addFromInput(searchInput)"
        (keydown.comma)="addFromInput(searchInput)"
      />
      <button
        type="button"
        class="search-btn"
        matTooltip="Buscar"
        (click)="addFromInput(searchInput)"
      >
        <mat-icon class="field-icon">search</mat-icon>
      </button>
    </div>
  </ng-container>

  <div
    class="filtro-item-field"
    *ngIf="modoHorario"
    (click)="openTimePicker()"
    (keydown.enter)="openTimePicker()"
    (keydown.space)="openTimePicker()"
    tabindex="0"
  >
    <span class="field-value">{{ (this.comparadoresTamanho | async) === 0 ? '00:00' : valorPrevio }}</span>
    <!-- Com horário selecionado, o relógio vira um X para limpar a seleção -->
    <mat-icon
      class="field-icon"
      svgIcon="clock"
      *ngIf="(comparadoresTamanho | async) === 0"
    ></mat-icon>
    <mat-icon
      class="field-icon field-icon-clear"
      *ngIf="(comparadoresTamanho | async) !== 0"
      matTooltip="{{ 'FILTER.REMOVE_FILTER' | translate }}"
      (click)="clearTime(); $event.stopPropagation()"
    >close</mat-icon>
  </div>

  <!-- Chips dos filtros de busca aplicados (multi-valor) -->
  <div class="chips-container" *ngIf="!modoHorario && (comparadores | async)?.length">
    <mat-chip-set>
      <mat-chip
        *ngFor="let comparador of comparadores | async"
        (removed)="remove(comparador)"
        [removable]="true"
        class="filter-chip"
      >
        {{ comparador }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-set>
  </div>
</div>

<app-custom-time-picker
  [isOpen]="isTimePickerOpen"
  [selectedTime]="selectedTime"
  (timeSelected)="onTimeSelected($event)"
  (closed)="onTimePickerClosed()"
></app-custom-time-picker>
